'strict'

const columns = {}
const files = require.context('./columns/', false, /\.*\.js$/);
files.keys().map(key => {
  columns[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

export default columns;